// In-app help assistant display name: Super Admin-configured per industry (Hardware → Eli, Fashion & Beauty → Emma).
// Served on GET /business as `helper_name`; tenant staff cannot override it. Falls back to Eli.
export const DEFAULT_HELPER_NAME = "Eli";
export const helperName = (business) => (business?.helper_name || "").trim() || DEFAULT_HELPER_NAME;
export const askLabel = (business) => `Ask ${helperName(business)}`;
export const helperInitial = (business) => helperName(business).charAt(0).toUpperCase();
